// Certified True Translation by Agency — 300-keyword clustered glossary (10 clusters)
// Powers /certified-translation/faq and /en/certified-translation/faq.
// Unique A5 copy, non-duplicative with MoJ/Sworn/Notary/Global hubs.
// Focus: agency stamp + signature for private sector, not court-level.

export type CtKeywordCluster = {
  id: string;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  keywords: string[];
  linkTh: string;
  linkEn: string;
};

export const CT_KEYWORD_CLUSTERS: CtKeywordCluster[] = [
  {
    id: "company-certified",
    titleTh: "รับรองคำแปลโดยบริษัท (Company Certified)",
    titleEn: "Company certified translation",
    descTh:
      "NYC ประทับตราบริษัท + ลายเซ็นผู้แปลบนทุกหน้าและ Certificate of Translation Accuracy แนบท้าย ยอมรับโดยบริษัทเอกชน, HR ต่างประเทศ, ธนาคาร, ประกันภัย เร็วกว่า MoJ/Sworn 50% เพราะไม่ต้องเข้าคิวราชการ",
    descEn:
      "NYC stamps every page with the company seal + translator signature, plus a Certificate of Translation Accuracy. Accepted by private firms, foreign HR, banks, and insurers — 50% faster than MoJ/Sworn because there's no government queue.",
    keywords: [
      "รับรองคำแปล", "บริการรับรองคำแปล", "รับรองความถูกต้องของคำแปล",
      "ประทับตราบริษัทแปล", "ศูนย์แปลรับรองเอกสาร", "บริการแปลพร้อมรับรอง",
      "Certified True Translation", "รับแปลและรับรองเอกสาร", "ตราประทับศูนย์แปล",
      "ลายเซ็นผู้แปลบริษัท", "รับรองคำแปลภาษาอังกฤษ", "แปลเอกสารรับรองบริษัท",
      "บริการรับรองเอกสารทุกภาษา", "แปลและเซ็นรับรอง",
      "รับแปลเอกสารพร้อมประทับตรา", "รับรองความถูกต้อง แปลไทยเป็นอังกฤษ",
      "รับรองความถูกต้อง แปลอังกฤษเป็นไทย", "ศูนย์แปลภาษาที่มีตราประทับ",
      "จดหมายรับรองคำแปล", "Certificate of Translation Accuracy",
      "สถาบันรับแปลเอกสาร", "รับแปลเอกสารและรับรองโดยบริษัท",
      "บริการแปลเอกสารเพื่อการพาณิชย์", "รับรองเอกสารสำหรับบริษัท",
      "แปลและรับรองเอกสารด่วน", "รับรองคำแปลโดยนักแปลมืออาชีพ",
      "รับรองความถูกต้องเอกสารธุรกิจ", "แปลเอกสารบริษัทรับรอง",
      "ศูนย์แปลภาษาที่เชื่อถือได้", "รับแปลเอกสารพร้อมใบรับรอง",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "employment-academic",
    titleTh: "สมัครงาน & ศึกษาต่อ",
    titleEn: "Employment & academic",
    descTh:
      "Resume/CV, Cover Letter, SOP, จดหมายแนะนำตัว, ประวัติการทำงาน — ผ่านการ proofread โดย native English editor ไม่ใช่ machine editor ราคา 1 หน้า ฿800, 2 หน้า ฿1,200 รวม editing",
    descEn:
      "Resumes, CVs, cover letters, SOPs, reference letters, and work histories — proofread by a native-English editor (not a machine). THB 800 for one page, THB 1,200 for two pages, editing included.",
    keywords: [
      "แปลเรซูเม่", "แปล CV", "แปลจดหมายแนะนำตัว", "แปล Cover Letter",
      "แปล SOP", "แปลเรียงความแนะนำตัว", "แปลจดหมายรับรองการทำงาน",
      "แปลประวัติการทำงาน", "แปลเอกสารสมัครงาน", "รับแปลเรซูเม่",
      "รับแปล Resume ด่วน", "แปลประวัติย่อ",
      "รับแปลจดหมายแนะนำตัวภาษาอังกฤษ", "แปล SOP เพื่อสมัครเรียน",
      "แปลเอกสารประกอบการสมัครงาน", "แปลเรซูเม่มืออาชีพ",
      "แปล Resume ภาษาอังกฤษ", "รับแปลเอกสารศึกษาต่อต่างประเทศ",
      "แปลจดหมายแนะนำตัวสมัครทุน", "แปล Statement of Purpose",
      "บริการแปลเรซูเม่", "รับแปล CV ภาษาอังกฤษ", "แปลจดหมายสมัครงาน",
      "แปลเอกสารยื่นมหาวิทยาลัย", "เขียนและแปลเรซูเม่ภาษาอังกฤษ",
      "แปลเอกสารรับรองทักษะ", "แปลจดหมายแนะนำตัวสมัครงาน",
      "แปลเอกสารประกอบการสมัครเรียน", "แปลเอกสาร CV",
      "บริการแปลเอกสารเพื่อการศึกษา",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "marketing-web",
    titleTh: "การตลาด & เว็บไซต์ (Localization)",
    titleEn: "Marketing & website localization",
    descTh:
      "เว็บไซต์, โบรชัวร์, แคตตาล็อก, สื่อโฆษณา, ซับไตเติ้ล, พรีเซนเทชั่น — NYC มี localization team ที่ปรับสำนวนตามตลาดปลายทาง (US/UK/AU/SG) ไม่ใช่แค่แปลตรงตัว รับส่งไฟล์ .po/.xliff/.srt",
    descEn:
      "Websites, brochures, catalogs, ad copy, subtitles, presentations — the localization team adapts tone for the target market (US/UK/AU/SG) rather than translating literally. Accepts .po/.xliff/.srt formats.",
    keywords: [
      "แปลเว็บไซต์", "แปลหน้าเว็บไซต์", "แปลภาษาเว็บไซต์", "แปลโบรชัวร์",
      "แปลแคตตาล็อกสินค้า", "แปลสื่อโฆษณา", "แปลเนื้อหาการตลาด",
      "แปลคำโฆษณา", "แปลซับไตเติ้ล", "แปล Subtitles",
      "รับแปลหน้าเว็บไซต์", "บริการแปลเว็บไซต์", "แปลคอนเทนต์การตลาด",
      "แปลคู่มือสินค้า", "แปลโบรชัวร์บริษัท", "แปลแคตตาล็อก",
      "แปลงานโฆษณา", "แปลวิดีโอ", "รับแปลซับไตเติ้ล",
      "บริการแปลสื่อประชาสัมพันธ์", "แปล content marketing",
      "แปลเว็บไซต์หลายภาษา", "Localization ภาษา", "แปลบทความโฆษณา",
      "แปลสคริปต์วิดีโอ", "แปลคำบรรยายสินค้า", "แปลสื่อสิ่งพิมพ์",
      "แปลโปรไฟล์บริษัท", "แปล Presentation", "รับแปลภาษาเพื่อการตลาด",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "languages",
    titleTh: "ภาษาที่ให้บริการรับรอง",
    titleEn: "Languages certified",
    descTh:
      "รับรองคำแปลใน 18 ภาษา ตราประทับเดียวกันทุกภาษา ผู้แปลลงชื่อพร้อมเลขทะเบียนบริษัท DBD ปรากฏบน Certificate — ตรวจสอบย้อนกลับได้ผ่านกรมพัฒนาธุรกิจการค้า",
    descEn:
      "Certification for 18 languages under one company seal. Each certificate carries the translator signature plus NYC's DBD registration number — verifiable via Thailand's Department of Business Development.",
    keywords: [
      "รับแปลภาษาอังกฤษ", "รับแปลภาษาจีน", "รับแปลภาษาญี่ปุ่น",
      "รับแปลภาษาเกาหลี", "รับแปลภาษาฝรั่งเศส", "รับแปลภาษาเยอรมัน",
      "รับแปลภาษาสเปน", "รับแปลภาษารัสเซีย", "รับแปลภาษาอาหรับ",
      "รับแปลภาษาพม่า", "รับแปลภาษากัมพูชา", "รับแปลภาษาเวียดนาม",
      "รับแปลภาษาลาว", "รับแปลภาษาอิตาลี", "รับแปลภาษาดัตช์",
      "รับแปลภาษาโปรตุเกส", "English to Thai Translation",
      "Thai to English Translation", "Chinese to Thai Translation",
      "Japanese to Thai Translation", "Korean to Thai Translation",
      "French to Thai Translation", "German to Thai Translation",
      "Spanish to Thai Translation", "Russian to Thai Translation",
      "Arabic to Thai Translation", "Vietnamese to Thai Translation",
      "Burmese to Thai Translation", "Cambodian to Thai Translation",
      "แปลภาษาต่างประเทศทั่วโลก",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "trust-intent",
    titleTh: "บริการ & ความเชื่อมั่น",
    titleEn: "Service intent & trust",
    descTh:
      "เปิดบริการมาตั้งแต่ 2553 · จดทะเบียน DBD · ISO 17100 workflow · ทีม account manager 6 คน · Response time 30 นาที · ลูกค้าองค์กรกว่า 800 ราย · รับ NDA และ PDPA compliance เต็มรูปแบบ",
    descEn:
      "Operating since 2010, DBD-registered, ISO 17100 workflow, 6 account managers, 30-minute response window, 800+ corporate clients — full NDA and Thai PDPA compliance on request.",
    keywords: [
      "แปลเอกสารด่วน", "แปลเอกสารรอรับได้เลย", "แปลเอกสารออนไลน์",
      "ศูนย์แปลภาษาใกล้ฉัน", "บริษัทแปลเอกสารคุณภาพ",
      "รับแปลเอกสารเชื่อถือได้", "แปลเอกสารราคาประหยัด",
      "รับแปลเอกสารราคากันเอง", "แปลเอกสารมืออาชีพ",
      "บริการแปลเอกสารแม่นยำ", "บริษัทแปลภาษามืออาชีพ",
      "ศูนย์แปลเอกสารภาษาต่างประเทศ", "แปลเอกสารราชการและธุรกิจ",
      "บริการแปลเอกสารครอบคลุม", "แปลเอกสารทุกประเภท",
      "จ้างแปลภาษาที่ไหนดี", "บริษัทแปลเอกสารแนะนำ",
      "แปลงานด่วนคุณภาพสูง", "บริการแปลเอกสารสำหรับบุคคล",
      "บริการแปลเอกสารสำหรับองค์กร", "ศูนย์แปลภาษาครบวงจร",
      "รับแปลภาษาออนไลน์ 24 ชม.", "แปลเอกสารด้วยนักแปลมืออาชีพ",
      "บริการแปลภาษาที่เน้นคุณภาพ", "ราคาแปลเอกสารมาตรฐาน",
      "แปลเอกสารส่งตรงถึงบ้าน", "บริการแปลงานออนไลน์ที่เชื่อถือได้",
      "บริษัทรับแปลภาษาที่ได้รับความนิยม", "รับแปลเอกสารอย่างเป็นทางการ",
      "บริการแปลภาษาด้วยความรวดเร็ว",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "longtail",
    titleTh: "Long-tail เฉพาะเจาะจง",
    titleEn: "Specific long-tail phrases",
    descTh:
      "โปรเจกต์เหมาจ่าย (retainer), งานพร้อมจัดหน้า (DTP), แปลจาก PDF เป็น Word/InDesign พร้อมส่งไฟล์ editable — เหมาะกับทีมการตลาด, ทีมกฎหมายภายใน, ทีมนำเข้าส่งออก",
    descEn:
      "Monthly retainers, DTP-included jobs, PDF→Word/InDesign with editable delivery — designed for in-house marketing, legal, and import/export teams.",
    keywords: [
      "รับแปล Resume ภาษาอังกฤษมืออาชีพ", "รับแปล Cover Letter ภาษาอังกฤษ",
      "บริการแปลเว็บไซต์เพื่อขยายตลาด", "แปลโบรชัวร์บริษัทภาษาอังกฤษ",
      "รับแปลแคตตาล็อกสินค้าพร้อมจัดหน้า",
      "แปลวิดีโอสื่อโฆษณาพร้อมฝังซับไตเติ้ล",
      "รับแปลงานวิจัยและบทความวิชาการ", "แปลเอกสารการประชุมบริษัท",
      "บริการแปลเรซูเม่เพื่อยื่นสมัครงานต่างชาติ",
      "แปลสัญญาซื้อขายสินค้าเบื้องต้น", "แปลนโยบายบริษัทเป็นภาษาอังกฤษ",
      "รับแปลเนื้อหาหน้าเว็บไซต์ทางการตลาด", "แปลไฟล์นำเสนองาน (Presentation)",
      "แปลคู่มือการใช้งานสำหรับพนักงาน",
      "บริการแปลและตรวจทานภาษาโดยเจ้าของภาษา",
      "แปลเอกสารยื่นประกอบการสมัครเรียน", "รับแปลงานสื่อสิ่งพิมพ์ทุกประเภท",
      "แปลบทความภาษาต่างประเทศ", "บริการแปลเอกสารองค์กรแบบเหมาจ่าย",
      "แปลเอกสารจากไฟล์ PDF เป็นภาษาไทย",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "expat-en",
    titleTh: "Expat / English Intent",
    titleEn: "Expat / English intent",
    descTh:
      "ลูกค้าต่างชาติในไทยและ HR ต่างประเทศชอบตราประทับ NYC เพราะไม่ต้องรอ MoJ หรือ Sworn — เร็วกว่า, ราคาถูกกว่า, ได้รับการยอมรับจากบริษัทเอกชนและมหาวิทยาลัยมากกว่า 90% ทั่วโลก",
    descEn:
      "Expats and foreign HR teams prefer NYC's company seal — faster than MoJ or Sworn, cheaper, and accepted by 90%+ of private companies and universities worldwide.",
    keywords: [
      "Document translation service Bangkok",
      "Official document translation Thailand",
      "Professional translation agency Thailand",
      "Business translation service Bangkok",
      "Marketing translation services Thailand",
      "Resume translation service English",
      "Website localization services Thailand",
      "Affordable translation services Bangkok",
      "Fast and reliable translation Thailand",
      "Document translation for private sector",
      "Certified translation services in Thailand",
      "Thai to English translation for business",
      "Professional resume and CV translation",
      "Corporate translation services Thailand",
      "English translation of marketing materials",
      "Subtitle translation services Thailand",
      "Translation agency with stamp and signature",
      "Translation of company documents",
      "Translate brochures and catalogs to Thai",
      "High-quality document translation Bangkok",
    ],
    linkTh: "/en/translate",
    linkEn: "/en/translate",
  },
  {
    id: "menu-blog",
    titleTh: "เมนูย่อย & บทความ",
    titleEn: "Menus & blog topics",
    descTh:
      "หัวข้อบทความสำหรับผู้ที่กำลังเปรียบเทียบระหว่าง MoJ, Sworn และ Company Certified — เนื้อหาช่วยให้ลูกค้าตัดสินใจได้เร็วขึ้นก่อนสั่งงาน ลด response back-and-forth ได้ 40%",
    descEn:
      "Comparison articles for buyers weighing MoJ vs Sworn vs Company Certified — content that speeds up decisions and cuts pre-order back-and-forth by 40%.",
    keywords: [
      "ความแตกต่างระหว่างแปลทั่วไปกับแปลรับรอง",
      "ทำไมต้องเลือกศูนย์แปลที่มีตราประทับ",
      "วิธีเขียนเรซูเม่ภาษาอังกฤษให้ผ่านฉลุย",
      "เคล็ดลับแปลเว็บไซต์ให้เข้าถึงลูกค้าต่างชาติ",
      "ขั้นตอนการใช้บริการแปลเอกสารออนไลน์",
      "แปลโบรชัวร์ให้ดึงดูดลูกค้าด้วยมืออาชีพ",
      "บริการแปลเอกสารสำหรับสมัครงานและศึกษาต่อ",
      "รับรองคำแปลคืออะไรและสำคัญอย่างไร",
      "รวมคำศัพท์ธุรกิจที่คนมักแปลผิด",
      "วิธีเลือกบริษัทแปลเอกสารให้คุ้มค่า",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "support-services",
    titleTh: "บริการเสริม (Proofread / DTP / Interpreter)",
    titleEn: "Value-added: proofread / DTP / interpreter",
    descTh:
      "Proofreading ฿0.8/คำ · Copy-editing ฿1.2/คำ · DTP (Adobe InDesign/Illustrator) ฿300/หน้า · ล่ามพูดตาม/พร้อม ฿4,000–8,000/ครึ่งวัน · ล่ามศาลตามอัตรากรมคุ้มครองสิทธิฯ",
    descEn:
      "Proofreading THB 0.8/word · Copy-editing THB 1.2/word · DTP (Adobe InDesign/Illustrator) THB 300/page · Consecutive/simultaneous interpretation THB 4,000–8,000 per half-day · Court interpreting at Ministry-set rates.",
    keywords: [
      "บริการตรวจทานภาษา (Proofreading)",
      "ตรวจสอบความถูกต้องงานแปล", "แก้ไขงานแปลจากที่อื่น",
      "ตรวจแก้ไวยากรณ์ภาษาอังกฤษ", "ปรับแก้สำนวนภาษา",
      "บริการจัดหน้าเอกสารให้เหมือนต้นฉบับ", "บริการพิมพ์เอกสาร",
      "บริการถอดเทปเสียง", "แปลจากไฟล์เสียง", "บริการล่ามแปลภาษา",
      "บริการล่ามพูดพร้อม", "ล่ามแปลภาษาสำหรับการประชุม",
      "บริการล่ามในศาล", "ล่ามพาติดต่อธุรกิจ",
      "ล่ามแปลภาษาสำหรับสัมมนา", "บริการจัดส่งเอกสารด่วน",
      "บริการสแกนเอกสาร", "บริการให้คำปรึกษาด้านภาษา",
      "บริการปรับภาษา (Localization)",
      "บริการแปลพร้อมจัดรูปแบบไฟล์ (Desktop Publishing - DTP)",
      "Proofreading service Thailand", "Editing and proofreading services",
      "Transcription services Bangkok", "Interpretation services Thailand",
      "Simultaneous interpretation", "Consecutive interpretation",
      "Language consultation service", "DTP translation service",
      "Document formatting service", "Confidential document translation",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
  {
    id: "industry-quality-decision",
    titleTh: "อุตสาหกรรม, คุณภาพ & Decision",
    titleEn: "Industry, quality & decision",
    descTh:
      "อุตสาหกรรมที่ NYC มีทีมเฉพาะ: กฎหมายระหว่างประเทศ, ก่อสร้าง, พลังงาน, อสังหาฯ, การเงินบัญชี, ท่องเที่ยว — ควบคุมคุณภาพด้วย 3-step review (translator → editor → proofreader) เทียบเท่า ISO 17100",
    descEn:
      "Dedicated teams for international law, construction, energy, real estate, finance, and tourism — with a 3-step review (translator → editor → proofreader) equivalent to ISO 17100.",
    keywords: [
      "แปลเอกสารกฎหมายระหว่างประเทศ", "แปลเอกสารโครงการก่อสร้าง",
      "แปลเอกสารสัมปทาน", "แปลเอกสารด้านพลังงานและปิโตรเลียม",
      "แปลเอกสารด้านการท่องเที่ยว", "แปลเอกสารด้านอสังหาริมทรัพย์",
      "แปลสัญญาร่วมทุน", "แปลนโยบายบริษัทข้ามชาติ",
      "แปลเอกสารความปลอดภัยและสิ่งแวดล้อม", "แปลเอกสารด้านบัญชีและการเงิน",
      "แปลรายงานงบดุลบริษัท", "แปลเอกสารการลงทุน",
      "แปลคู่มือการบริหารจัดการ", "แปลเอกสารประมูลงาน",
      "แปลเอกสารสเปคสินค้า", "Legal translation for international law",
      "Construction project translation", "Energy and petroleum translation",
      "Real estate translation service", "Financial and accounting translation",
      "Investment document translation", "Tender document translation",
      "Environmental and safety document translation",
      "Corporate policy translation", "Specialized industry translation",
      "การแปลโดยเจ้าของภาษา (Native Speaker Translation)",
      "นักแปลที่มีประสบการณ์สูง", "ทีมงานนักแปลเฉพาะทาง",
      "รับประกันความถูกต้องของงานแปล", "การเก็บรักษาความลับของเอกสาร",
      "บริการแปลที่เน้นความเป็นส่วนตัว", "ความเชี่ยวชาญด้านคำศัพท์เฉพาะทาง",
      "ระบบควบคุมคุณภาพงานแปล", "นักแปลที่เข้าใจวัฒนธรรมท้องถิ่น",
      "บริการแปลที่เป็นธรรมชาติ", "งานแปลตรงตามต้นฉบับ 100%",
      "บริการแปลที่เป็นที่ยอมรับในระดับสากล",
      "นักแปลที่มีใบรับรองระดับมืออาชีพ", "Native English Translator",
      "Native Chinese Translator", "High-quality translation assurance",
      "Confidentiality guaranteed translation", "Expert linguist team",
      "Culturally accurate translation",
      "Professional quality control translation",
      "Trustworthy translation partner", "International standard translation",
      "Experienced professional translators", "Precise terminology translation",
      "Guaranteed customer satisfaction",
      "อันดับศูนย์แปลเอกสารที่ดีที่สุด", "ศูนย์แปลภาษายอดนิยม",
      "คำแนะนำในการเลือกศูนย์แปล", "ประสบการณ์มากกว่า 10 ปี",
      "ลูกค้าองค์กรชั้นนำเลือกใช้บริการ",
      "บริการแปลที่ได้รับคำชมจากลูกค้า", "งานแปลราคาคุ้มค่าคุณภาพสูง",
      "ติดต่อจ้างแปลเอกสาร", "สอบถามข้อมูลบริการแปลภาษา",
      "ขอใบเสนอราคาแปลเอกสาร", "รับประเมินราคาแปลเอกสารฟรี",
      "ส่งไฟล์เพื่อประเมินราคา", "บริษัทแปลที่ตอบกลับรวดเร็ว",
      "ทีมงานแปลภาษาดูแลลูกค้าดี", "ศูนย์แปลภาษาที่อยู่ใจกลางเมือง",
      "บริการแปลภาษาระดับพรีเมียม", "ทางเลือกใหม่ในการแปลเอกสาร",
      "โซลูชั่นการแปลสำหรับธุรกิจคุณ", "พันธมิตรด้านภาษาของคุณ",
      "ครบเครื่องเรื่องงานแปลเอกสาร",
    ],
    linkTh: "/translate",
    linkEn: "/en/translate",
  },
];

export const CT_MISSPELLINGS: { wrong: string; right: string }[] = [
  { wrong: "รับรองความถูกตอง", right: "รับรองความถูกต้อง" },
  { wrong: "ประทับตราบริษัท", right: "ประทับตราบริษัท" },
  { wrong: "โลคอลไลเซชั่น", right: "Localization" },
  { wrong: "โปรฟรีดดิ้ง", right: "Proofreading" },
  { wrong: "แคตตาลอค", right: "แคตตาล็อก" },
];
